import {
    GET_STATISTICS_BY_DOMAIN_REQUEST,
    GET_STATISTICS_BY_DOMAIN_SUCCESS,
    GET_STATISTICS_BY_DOMAIN_FAILED,
    GET_STATISTICS_BY_CATEGORY_REQUEST,
    GET_STATISTICS_BY_CATEGORY_SUCCESS,
    GET_STATISTICS_BY_CATEGORY_FAILED,
    GET_STATISTICS_BY_DOMAIN_BY_DAYS_SUCCESS,
    GET_STATISTICS_BY_DOMAIN_BY_DAYS_FAILED,
    GET_LOG_STATISTICS_SUCCESS,
    GET_LOG_STATISTICS_FAILED,
    GET_LOG_TYPES_SUCCESS,
    GET_LOG_TYPES_FAILED,
    GET_STATISTICS_FOR_STORIES_REQUEST,
    GET_STATISTICS_FOR_STORIES_SUCCESS,
    GET_STATISTICS_FOR_STORIES_FAILED
} from '../../actions/statistics/get-statistics'

const initialState = {
    statistics: null,
    statisticsCategory: null,
    requestingStatisticsCategory: false,
    currentMonthStatistics: [],
    requesting: false,
    error: null,
    logStatistics: [],
    logList: [],
    timeFrameDay: [],
    timeFrameWeek: [],
    timeFrameMonth: [],
    timeFrameYear: [],
    logStatisticsError: null,
    logTypes: [],
    logTypesError: null
}

export const statistics = (state = initialState, action) => {
    switch (action.type) {
        case GET_STATISTICS_BY_DOMAIN_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                statistics: null,
                error: null
            })
        case GET_STATISTICS_BY_DOMAIN_SUCCESS:
            return Object.assign({}, state, {
                statistics: action.payload.data.payload,
                requesting: false,
                error: null,
            })
        case GET_STATISTICS_BY_DOMAIN_FAILED:
            return Object.assign({}, state, {
                statistics: null,
                requesting: false,
                error: action.error
            })
        case GET_STATISTICS_FOR_STORIES_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                statistics: null,
                error: null
            })
        case GET_STATISTICS_FOR_STORIES_SUCCESS:
            return Object.assign({}, state, {
                statistics: action.payload.data.payload,
                requesting: false,
                error: null,
            })
        case GET_STATISTICS_FOR_STORIES_FAILED:
            return Object.assign({}, state, {
                statistics: null,
                requesting: false,
                error: action.error
            })
        case GET_STATISTICS_BY_CATEGORY_REQUEST:
            return Object.assign({}, state, {
                requestingStatisticsCategory: true,
                statisticsCategory: null,
                errorStatisticsCategory: null
            })
        case GET_STATISTICS_BY_CATEGORY_SUCCESS:
            return Object.assign({}, state, {
                statisticsCategory: action.payload.data.payload,
                requestingStatisticsCategory: false,
                errorStatisticsCategory: null,
            })
        case GET_STATISTICS_BY_CATEGORY_FAILED:
            return Object.assign({}, state, {
                statisticsCategory: null,
                requestingStatisticsCategory: false,
                errorStatisticsCategory: action.error
            })
        case GET_STATISTICS_BY_DOMAIN_BY_DAYS_SUCCESS:
            return Object.assign({}, state, {
                currentMonthStatistics: action.payload.data.payload,
                error: null,
            })
        case GET_STATISTICS_BY_DOMAIN_BY_DAYS_FAILED:
            return Object.assign({}, state, {
                currentMonthStatistics: null,
                error: action.error
            })
        case GET_LOG_STATISTICS_SUCCESS:
            return Object.assign({}, state, {
                logStatistics: action.payload.data.payload,
                logList: action.payload.data.payload.logList,
                timeFrameDay: action.payload.data.payload.timeFrameDay,
                timeFrameWeek: action.payload.data.payload.timeFrameWeek,
                timeFrameMonth: action.payload.data.payload.timeFrameMonth,
                timeFrameYear: action.payload.data.payload.timeFrameYear,
                logStatisticsError: null,
            })
        case GET_LOG_STATISTICS_FAILED:
            return Object.assign({}, state, {
                logStatistics: null,
                logList: [],
                timeFrameDay: [],
                timeFrameWeek: [],
                timeFrameMonth: [],
                timeFrameYear: [],
                logStatisticsError: action.error
            })
        case GET_LOG_TYPES_SUCCESS:
            return Object.assign({}, state, {
                logTypes: action.payload.data.payload,
                logTypesError: null
            })
        case GET_LOG_TYPES_FAILED:
            return Object.assign({}, state, {
                logTypes: action.payload.data.payload,
                logTypesError: action.error
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/statistics/statistics.js